import React from 'react'
import { NavLink } from 'react-router-dom'
import SiteIcons from '../assets/SiteIcons'
import styled from 'styled-components'

const MobileNav = (props) => {

  let logText

  if ( props.loggedIn === false ) {
    logText = 'Preview Login'
  } else {
    logText = 'Log out'
  }

  const NavChange = () => {
    props.toggleMobileNav()
  }

  let showMe = ''

  if ( props.showState === true ) {
    showMe = ' show'
  } else {
    showMe = ''
  }

  const MobileNavStyles = styled.div`
    ul {
      li {
        a {
          color: white;

          .icon {
            #lines {
              stroke: white;
            }

            #accent {
              stroke: white;
            }

            #fill {
              fill: none;
            }

          }

          &:hover {
            color: ${props.themeStyles.mainColor};

            .icon {
              #lines, #accent {
                stroke: ${props.themeStyles.mainColor};
              }

            }
          }

        }
      }
    }
  `


  return (
    <MobileNavStyles id="mobileNavDropDown" className={showMe}>
      <ul>
        <li><NavLink onClick={NavChange} activeClassName="active" to={"/courses/all-courses"}><span>Courses</span><SiteIcons icon='courses' /></NavLink></li>
        <li><NavLink onClick={NavChange} exact activeClassName="active" to={"/requirements"}><span>System</span><SiteIcons icon='system' /></NavLink></li>
        <li><a onClick={NavChange} href={'https://' + props.localURL + '/index.php/json/login'}><span>{logText}</span><SiteIcons icon='login' /></a></li>
        {props.themeLinks.map((link,id) =>
          <li key={id}><a onClick={NavChange} href={link[1]} target="_blank"><span>{link[0]}</span><SiteIcons icon='links' /></a></li>
        )}
      </ul>

    </MobileNavStyles>
  )
}

export default MobileNav
